import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import useRoot from '../../1_application/core/roots/rootController';
import useUser from '../../1_application/user/userController';
import { UserLoginState } from '../../2_domain/user/user';
import ForgetPage from '../auth/forgetPage';
import ResetPage from '../auth/resetPage';
import SignInPage from '../auth/signInPage';
import SuccessPage from '../auth/successPage';
import PatientRouter from '../client/router';
import DashboardPage from '../dashboard/dashboardPage';
import NotificationPage from '../notification/notificationPage';
import ChangePasswordPage from '../resetPassword/changePasswordPage';
import SplashPage from '../splash/splashPage';
import SupportPage from '../support/supportPage';
import LXLayout from './components/layout';
import NotFoundPage from './notFound';
import SettingRouter from '../setting/router';
import TestRouter from '../test/router';
import LXDialog from './components/feedback/dialog';
import TestAllPage from '../admin/testAllPage';

const LXRouter: React.FC = () => {
  const { user, initUser } = useUser();
  const { init } = useRoot();

  useEffect(() => {
    initUser();
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (user.loginState === UserLoginState.default) {
    return (
      <>
        <Routes>
          <Route path="*" element={<SplashPage />} />
          <Route path="signIn" element={<SignInPage />} />
          <Route path="forget" element={<ForgetPage></ForgetPage>} />
          <Route path="reset" element={<ResetPage></ResetPage>} />
          <Route path="success" element={<SuccessPage></SuccessPage>} />
        </Routes>
      </>
    );
  } else if (user.loginState === UserLoginState.logined) {
    return (
      <>
        <Routes>
          <Route element={<LXLayout></LXLayout>}>
            <Route path="*" element={<NotFoundPage />} />
            <Route index element={<Navigate replace to="dashboard" />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="patient/*" element={<PatientRouter />}></Route>
            <Route path="setting/*" element={<SettingRouter />}></Route>
            <Route path="test/*" element={<TestRouter />}></Route>
            <Route path="support" element={<SupportPage />} />
            <Route path="changePassword" element={<ChangePasswordPage />} />
            <Route path="notification" element={<NotificationPage />} />
            <Route path="admin/account/add" element={<p>hi</p>}></Route>
            <Route
              path="admin/test/all"
              element={<TestAllPage></TestAllPage>}
            ></Route>
          </Route>
        </Routes>
        <LXDialog></LXDialog>
      </>
    );
  } else {
    return <div>Invalid Login State Detected. Refresh Web Please</div>;
  }
};

export default LXRouter;
